/* Расчёт реза — сколько погонных метров нужно на планки разной высоты.

   Живёт отдельным файлом, а не в theme.js: блок рисуется на считанных
   карточках каталога, а theme.js грузится на каждой странице магазина —
   от корзины до статьи блога. Класть туда арифметику одного товара значит
   возить её по всему сайту.

   Денег этот файл не считает. Метры уходят в обычный счётчик количества,
   он остаётся в разметке скрытым, а дальше сумму в кнопке, оптовые пороги
   и правило кратности пересчитывает theme.js — тем же кодом, что и у любого
   другого товара. Две реализации одной цены на одной странице однажды
   разошлись бы, и разошлись бы молча. */

(() => {
  const parse = (input) => {
    const value = parseInt(input.value, 10);
    return Number.isFinite(value) ? value : 0;
  };

  /* Метры строки: высота в миллиметрах на количество планок.
     Округление до сантиметра — иначе 0.1 + 0.2 показало бы хвост
     из двоичной дроби прямо в разметке. */
  const rowMeters = (mm, quantity) => Math.round((mm * quantity) / 10) / 100;

  const format = (meters) => meters.toFixed(2).replace('.', ',');

  function setup(root) {
    const settings = JSON.parse(root.querySelector('[data-cut-settings]').textContent);
    const template = root.querySelector('[data-cut-template]');
    const rows = root.querySelector('[data-cut-rows]');
    const form = root.closest('form');
    if (!template || !rows || !form) return;

    const quantityInput = form.querySelector('[data-quantity-input]');
    const property = form.querySelector('[data-cut-property]');
    const submit = form.querySelector('[type="submit"]');
    const error = root.querySelector('[data-cut-error]');
    const note = root.querySelector('[data-cut-note]');
    // И в рамке итога, и в кнопке — theme.js пишет цену в оба места разом,
    // значит и гасить их надо разом, иначе кнопка останется с прошлой суммой.
    const totals = form.querySelectorAll('[data-line-total]');
    const out = (name) => root.querySelector(`[data-cut-out="${name}"]`);

    // Последнее, что мы положили в счётчик. Он вправе поправить число под
    // правило кратности оптовой локации, и без этой памяти мы бы отправляли
    // ему исправленное значение обратно на каждый пересчёт.
    let sent = null;

    function recalculate() {
      let pieces = 0;
      let meters = 0;
      let invalid = false;
      const parts = [];

      root.querySelectorAll('[data-cut-row]').forEach((row) => {
        const field = row.querySelector('[data-cut-size]');
        const quantity = Math.max(0, parse(row.querySelector('[data-cut-quantity]')));
        const cell = row.querySelector('[data-cut-meters]');

        /* Незаполненная высота — не ошибка, а строка, которую только что
           добавили: количество в ней уже стоит единицей, и считать пустое
           поле за «0 мм» значило бы ругаться на человека раньше, чем он
           успел набрать первую цифру. */
        if (field.value.trim() === '') {
          cell.textContent = '—';
          return;
        }

        const mm = parse(field);
        if (mm < settings.min || mm > settings.max) {
          invalid = true;
          cell.textContent = '—';
          return;
        }
        if (quantity < 1) {
          cell.textContent = '—';
          return;
        }

        const rowValue = rowMeters(mm, quantity);
        cell.textContent = format(rowValue);
        pieces += quantity;
        meters += rowValue;
        parts.push(`${mm} × ${quantity} ${settings.pieces}`);
      });

      meters = Math.round(meters * 100) / 100;
      const billed = Math.ceil(meters);

      /* Потолок счётчика. Прежде расчёт молча упирался в него: человек
         набирал 1080 метров, а в заказ уходило 999 — и разницу он узнавал
         бы уже от нас. Теперь заказ просто не собрать, и сказано почему. */
      const overMax = billed > settings.maxMeters;

      let message = '';
      if (invalid) message = settings.outOfRange;
      else if (overMax) message = settings.overMax;
      error.textContent = message;
      error.hidden = message === '';

      // Убрать последнюю строку нельзя: без строк блок нечем заполнять.
      const removals = root.querySelectorAll('[data-cut-remove]');
      removals.forEach((button) => {
        button.disabled = removals.length < 2;
      });

      if (property) property.value = parts.join('; ');

      /* Метры отдаём счётчику и сообщаем об изменении: слушатель в theme.js
         разложит их в скрытое поле quantity и в сумму на кнопке. За потолком
         не отдаём вовсе — счётчик обрезал бы число, и в рамке встала бы
         чужая цифра вместо той, которую человек насчитал. */
      if (overMax) {
        /* Счётчику не отдаём, но и память о переданном сбрасываем: вернувшись
           в допустимое, расчёт обязан снова разбудить theme.js. Иначе число
           совпало бы с прошлым, будить было бы «нечего», и в рамке остался бы
           прочерк вместо восстановленной цены. */
        sent = null;
      } else if (quantityInput && billed !== sent) {
        sent = billed;
        quantityInput.value = String(billed);
        quantityInput.dispatchEvent(new Event('change', {bubbles: true}));
      }

      /* Показываем то число, которое в счётчике и осталось: у оптовой
         локации бывает кратность, и она поднимет 38 до 40. Написать «38»
         рядом с суммой за 40 значит соврать в единственной строке,
         ради которой блок и затевался. */
      const charged = overMax || !quantityInput ? billed : Number(quantityInput.value) || billed;

      out('pieces').textContent = pieces ? String(pieces) : '—';
      out('meters').textContent = pieces ? format(meters) : '—';
      out('billed').textContent = pieces ? String(charged) : '—';

      /* Цены нет, пока нечего покупать: до первой планки счётчик стоит
         на своём минимуме, а за потолком его значение к расчёту отношения
         не имеет. И в том, и в другом случае сумма рядом с прочерком
         читалась бы как цена того, чего не заказывали. */
      if (pieces === 0 || overMax) {
        totals.forEach((node) => {
          node.textContent = '—';
        });
      }

      note.hidden = !(pieces > 0 && !overMax && charged !== meters);

      if (submit) submit.disabled = pieces < 1 || message !== '';
    }

    function addRow() {
      rows.append(template.content.cloneNode(true));
      recalculate();
      const added = rows.querySelector('[data-cut-row]:last-child [data-cut-size]');
      if (added) added.focus();
    }

    root.querySelector('[data-cut-add]').addEventListener('click', addRow);

    root.addEventListener('input', (event) => {
      if (event.target.closest('[data-cut-row]')) recalculate();
    });

    root.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-cut-remove]');
      if (!remove || remove.disabled) return;
      remove.closest('[data-cut-row]').remove();
      recalculate();
    });

    // Первая строка — сразу: пустой блок не объясняет, что с ним делать.
    rows.append(template.content.cloneNode(true));
    recalculate();
  }

  const start = () => document.querySelectorAll('[data-cut]').forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
